import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {
    httpGetMedicalRecordAggregatedPrint,
    HttpGetMedicalRecordAggregatedPrintPayload
} from '@/features/medical-records/http/medicalRecords.http'
import {AxiosError} from 'axios'
import {MedicalRecordAggregatedPrint} from '@/features/medical-records/types'
import {MUTATION_KEYS} from '@/queryClient'

export const useGetMedicalRecordAggregatePrints = (
    options: Omit<
        UseMutationOptions<MedicalRecordAggregatedPrint, AxiosError, HttpGetMedicalRecordAggregatedPrintPayload>,
        'mutationFn'
    >
) =>
    useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.GET_MEDICAL_RECORD_AGGREGATED_PRINTS],
        mutationFn: httpGetMedicalRecordAggregatedPrint
    })
